import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "kefu-popup-wrap"
};
var _hoisted_2 = {
  class: "kefu-close-row"
};
var _hoisted_3 = {
  class: "kefu-popup-body"
};
var _hoisted_4 = {
  class: "kefu-card"
};
var _hoisted_5 = {
  class: "kefu-qr-frame"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "kefu-card"
};
var _hoisted_8 = {
  class: "kefu-email-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");
  var _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $props.show,
    class: "creator-contest-kefu-popup",
    position: "center",
    "overlay-style": $data.overlayStyle,
    "close-on-click-overlay": true,
    "onUpdate:show": $options.onUpdateShow
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        type: "button",
        class: "kefu-close-btn",
        "aria-label": "关闭",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.onCloseClick && $options.onCloseClick.apply($options, arguments);
        })
      }, [_createVNode(_component_van_icon, {
        name: "cross",
        class: "kefu-close-icon"
      })])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "kefu-title"
      }, "联系客服进行问题反馈", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "kefu-sub"
      }, "长按保存二维码", -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: "kefu-qr-img",
        src: $options.resolvedQrSrc,
        alt: "客服二维码，长按二维码保存"
      }, null, 8, _hoisted_6)])]), _createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "kefu-title"
      }, "联系邮箱", -1)), _createElementVNode("button", {
        type: "button",
        class: "kefu-email-row",
        onClick: _cache[1] || (_cache[1] = function () {
          return $options.onCopyEmail && $options.onCopyEmail.apply($options, arguments);
        })
      }, [_createElementVNode("span", _hoisted_8, _toDisplayString($props.contactEmail), 1), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "kefu-copy-wrap",
        "aria-hidden": "true"
      }, [_createElementVNode("svg", {
        class: "kefu-copy-svg",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("rect", {
        x: "9",
        y: "9",
        width: "11",
        height: "11",
        rx: "2",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.5"
      }), _createElementVNode("rect", {
        x: "4",
        y: "4",
        width: "11",
        height: "11",
        rx: "2",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.5"
      })])], -1))])])])])];
    }),
    _: 1
  }, 8, ["show", "overlay-style", "onUpdate:show"]);
}